/** @jsx jsx */
/** @jsxFragment */
import { ClassNames, jsx } from '@emotion/react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Reference } from 'types/Reference';
import ReferenceListCard from './ReferenceListCard';
import ReferenceListCardLogo from './ReferenceListCardLogo';

export interface ReferenceListProps extends React.HTMLAttributes<HTMLDivElement> {
  references: Reference[];
}

const ReferenceList: React.FC<ReferenceListProps> = ({ references }) => {
  const textReferences = references && references.filter((r) => r.text);
  const logoReferences = references && references.filter((r) => !r.text);
  return (
    <div>
      <ClassNames>
        {() => (
          <React.Fragment>
            {textReferences && textReferences.length ? (
              <div>
                <div>
                  <h2>
                    <FormattedMessage id={'references.textReferencesTitle'} />
                  </h2>
                </div>
                <div
                  css={{
                    '@media(min-width: 600px)': {
                      gridTemplateColumns: '1fr 1fr',
                    },
                    '@media(min-width: 960px)': {
                      gridTemplateColumns: '1fr 1fr 1fr',
                    },
                    columnGap: '30px',
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gridTemplateRows: ' 1fr',
                    marginTop: '40px',
                    maxWidth: '1166px',
                    rowGap: '15px',
                  }}
                >
                  {textReferences.map((r, idx) => (
                    <ReferenceListCard key={idx.toString()} reference={r} />
                  ))}
                </div>
              </div>
            ) : null}
            {logoReferences && logoReferences.length ? (
              <div>
                <div>
                  <h2 css={{ marginTop: '40px' }}>
                    <FormattedMessage id={'references.logoReferencesTitle'} />
                  </h2>
                </div>
                <div
                  css={{
                    '@media(min-width: 600px)': {
                      gridTemplateColumns: '1fr 1fr',
                    },
                    '@media(min-width: 960px)': {
                      gridTemplateColumns: '1fr 1fr 1fr',
                    },
                    columnGap: '30px',
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gridTemplateRows: ' 1fr 1fr 1fr',
                    marginBottom: '40px',
                    marginTop: '40px',
                    maxWidth: '1166px',
                    rowGap: '15px',
                  }}
                >
                  {logoReferences &&
                    logoReferences.map((r, idx) => <ReferenceListCardLogo key={idx.toString()} reference={r} />)}
                </div>
              </div>
            ) : null}
          </React.Fragment>
        )}
      </ClassNames>
    </div>
  );
};

export default ReferenceList;
